











//
// WARNING
// This file is auto-generated by Commands.tst
// Don't try to edit it, your changes will be lost.
// If you nedd to change this file, edit Commands.tst.
//

import { Command } from "@signature/crs-client";
import { endpoint, CommandResult } from '@/modules/crs/crs';


    

    @Command('Automelec.Model-Automelec.Model.Commands.ProductionSite.CreateProductionSiteCommand')
    
    export class CreateProductionSiteCommand {
        constructor( name: string ) {
            
                this.name = name;
            
        }

        
            public name: string;
        
    }

    export interface ICreateProductionSiteCommand {
        
            name: string;
        
    }

    export async function createProductionSite( command: CreateProductionSiteCommand ): Promise<CommandResult<number>>
    export async function createProductionSite( { name }: ICreateProductionSiteCommand ): Promise<CommandResult<number>>
    export async function createProductionSite( model: any ): Promise<CommandResult<number>> {
        if(model == null) throw new Error("Command cannot be null.");

        var result: CommandResult<number>;

        if(model instanceof CreateProductionSiteCommand) {
            result = await endpoint.send<CommandResult<number>>(model);
        }
        else {
            result = await endpoint.send<CommandResult<number>>( new CreateProductionSiteCommand( model['name'] ) );
        }

        return result;
    }

    /**
    * Extraneous types
    */
    export namespace CreateProductionSiteCommand.ExtraneousTypes {
        

        
    }

